<template lang="pug">
    div.wrapper
        div.textBlock

            // Title
            title-component(h1 :title="$t('rateChallenge.title')")

            // Description
            div.description {{ $t('rateChallenge.description') }}

        // Rating
        rating
</template>

<script>
    import Rating from './Rating';
    import Title from '~components/Title';

    export default {
        components: {
            Rating,
            TitleComponent: Title
        }
    };
</script>

<style lang="stylus" scoped>
    .wrapper
        display: flex
        align-items: center
        flex-direction: column
        position: relative

    .textBlock
        max-width: 460px
        text-align: center
        position: relative
        z-index: 2

    .footerText
        text-align: center
</style>
